import { logger } from '@/lib/logger'

import './types'

/**
 * Initialize Google Tag Manager
 */
export const initGTM = (): void => {
  const containerId = import.meta.env.VITE_GTM_CONTAINER_ID

  if (!containerId) {
    logger.error('GTM container ID not found in environment variables')
    return
  }

  try {
    window.dataLayer = []
    window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' })

    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.googletagmanager.com/gtm.js?id=${containerId}`
    document.head.appendChild(script)

    logger.info('GTM initialized successfully')
  } catch (error) {
    logger.error('Failed to initialize GTM', { error })
  }
}
